import * as React from "react";
const SvgFiRrBio = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bio_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m4.7-14a2.3 2.3 0 0 0-2.3 2.3v3.4c0 1.269 1.031 2.3 2.3 2.3s2.3-1.031 2.3-2.3v-3.4C19 9.031 17.969 8 16.7 8m.7 5.7a.7.7 0 0 1-1.4 0v-3.4a.7.7 0 0 1 1.4 0zM13 8.8v6.4a.8.8 0 1 1-1.6 0V8.8a.8.8 0 1 1 1.6 0m-3.001 1.434C9.963 8.966 8.828 8 7.56 8H6.5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1.374c1.249 0 2.395-.86 2.593-2.094a2.48 2.48 0 0 0-.868-2.312c.264-.386.414-.855.4-1.36M7.1 9.599h.6a.7.7 0 0 1 0 1.4h-.6zm.9 4.8h-.9v-1.8H8c.496 0 .9.404.9.9s-.404.9-.9.9"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bio_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBio;
